import ReceberAnexoService from "@/services/ReceberAnexoService";

export const receberAnexo = {
  namespaced: true,
  state: {
    receberAnexo: {},
  },
  actions: {
    getReceberAnexo({ commit }, payload) {
      return ReceberAnexoService.GetReceberAnexo(payload).then(
        (receberAnexo) => {
          return Promise.resolve(receberAnexo);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postReceberAnexo({ commit }, payload) {
      return ReceberAnexoService.PostReceberAnexo(payload).then(
        (receberAnexo) => {
          return Promise.resolve(receberAnexo);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putReceberAnexo({ commit }, payload) {
      return ReceberAnexoService.PutReceberAnexo(payload).then(
        (receberAnexo) => {
          return Promise.resolve(receberAnexo);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteReceberAnexo({ commit }, payload) {
      return ReceberAnexoService.DeleteReceberAnexo(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getReceberAnexoOData({ commit }, payload) {
      return ReceberAnexoService.GetReceberAnexoOData(payload).then(
        (receberAnexo) => {
          return Promise.resolve(receberAnexo);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default receberAnexo;
